import { render, staticRenderFns } from "./Lifestyle.vue?vue&type=template&id=e4659a64&scoped=true"
import script from "./Lifestyle.vue?vue&type=script&lang=js"
export * from "./Lifestyle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4659a64",
  null
  
)

export default component.exports